
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "I should post more";
export const description = "Thoughts on post frequency.";
export const image = "/blog-images/lakeview-topaz-upscale-3x-grain.jpg";
export const tags = ["Meta", "Update"];
function _createMdxContent(props) {
  const _components = {
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/lakeview-topaz-upscale-3x-grain.jpg",
        alt: ""
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Sun Microsystems/Oracle. Desktop background included with Solaris 10."]
      }), _jsx("br", {}), _jsx("subt", {
        children: "Locally AI-upscaled and cleaned up with Topaz Photo."
      })]
    }), "\n", _jsx(_components.p, {
      children: "I really want to start posting on this blog more often. I have a slightly longer post in the works right now, and a whole pile of discards that I couldn't get to be the length I wanted."
    }), "\n", _jsx(_components.p, {
      children: "But then again, I could just start writing more short posts so I don't have to keep to that high standard."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	